import { render, staticRenderFns } from "./invoice-dialog-income.vue?vue&type=template&id=89b7ad3e&scoped=true"
import script from "./invoice-dialog-income.vue?vue&type=script&lang=js"
export * from "./invoice-dialog-income.vue?vue&type=script&lang=js"
import style0 from "./invoice-dialog-income.vue?vue&type=style&index=0&id=89b7ad3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b7ad3e",
  null
  
)

export default component.exports